(function ($) {
  'use strict';

  this.PersonalityTest = function () {
    if (!window.ys || typeof window.ys.ptr === 'undefined') {
      console.log('Results are not defined');
      return;
    }

    this.currentQuestion = 1;

    this.$test = $('section#personality-test');
    this.$questionWrap = this.$test.find('.question-wrapper');

    if (this.$test.length < 1 || this.$questionWrap.length < 1) {
      console.log('Could not initialize the personality test');
      return;
    }

    this.totalQuestions = this.$questionWrap.find('.question').length;

    this.$progress = this.$questionWrap.find('.progress');

    // Reset the test
    this.reset();

    // Move the form to the next question
    $(document).on(
      'click',
      '#personality-test .answers .box button',
      this.nextQuestion.bind(this)
    );

    // Toggle the answer on/off
    $(document).on(
      'click',
      '#personality-test .answer',
      this.toggleAnswer.bind(this)
    );

    // Navigate to already answered question
    $(document).on(
      'click',
      '#personality-test .progress span',
      this.progressClick.bind(this)
    );

    // Navigate to already answered question
    $(document).on('click', '#personality-test .share a', this.sharePersona);

    // Hooks when answer changes
    this.$test.on(
      'PersonalityTest:answer:changed',
      this.renderProgress.bind(this)
    );
    this.renderProgress();
  };

  /**
   * Enable navigation through progress buttons
   */
  this.PersonalityTest.prototype.renderProgress = function () {
    this.$progress.find('span').css('cursor', 'default').data('enabled', null);
    // Add cursor and enable the span to navigate only to answered questions
    var lastQuestion = 0;
    for (var question in this.answers) {
      if (
        this.answers.hasOwnProperty(question) &&
        this.answers[question].length > 0
      ) {
        if (question > lastQuestion) {
          lastQuestion = parseInt(question);
        }
        this.$progress
          .find('span:nth-child(' + question + ')')
          .css('cursor', 'pointer')
          .data('enabled', true);
      }
    }
    this.$progress
      .find('span:nth-child(' + (lastQuestion + 1) + ')')
      .css('cursor', 'pointer')
      .data('enabled', true);
  };

  /**
   * Move the form to the next question
   */
  this.PersonalityTest.prototype.nextQuestion = function (e) {
    var $button = $(e.currentTarget);
    var $question = $button.closest('.question');
    var questionNumber = $question.index() + 1;
    if (
      !this.answers[questionNumber] ||
      this.answers[questionNumber].length < 1
    ) {
      $question.find('input').prop('checked', false).removeAttr('checked');
      $question.find('.select-answer').slideDown();
      return;
    }

    this.keepOnTop();

    $button.attr('disabled', true);
    $question.addClass('answered');
    var nextQuestion = $question.index() + 2;
    if (this.goToQuestion(nextQuestion)) {
      if (typeof dataLayer !== 'undefined') {
        // GTM statistics event
        dataLayer.push({
          event: 'gaEvent',
          eventCategory: 'TDF2017 - Personality test',
          eventAction: 'Answered question',
          eventLabel: nextQuestion - 1,
        });
      }

      this.$test.trigger({
        type: 'PersonalityTest:question:next',
        currentQuestion: nextQuestion - 1,
        nextQuestion: nextQuestion,
      });
    }
    $button.removeAttr('disabled');
  };

  /**
   * Move the form to the question selected by the progress button
   */
  this.PersonalityTest.prototype.progressClick = function (e) {
    var $button = $(e.currentTarget);
    if (!$button.data('enabled')) {
      return;
    }

    var $question = $button.closest('.question');
    var questionNumber = $question.index() + 1;
    if (
      !this.answers[questionNumber] ||
      this.answers[questionNumber].length < 1
    ) {
      $question.find('input').prop('checked', false).removeAttr('checked');
      $question.find('.select-answer').slideDown();
      return;
    }

    this.goToQuestion($button.index() + 1);
  };

  /**
   * Move the form to selected question
   */
  this.PersonalityTest.prototype.goToQuestion = function (question) {
    if (!question || typeof question !== 'number') {
      question = this.currentQuestion + 1;
    }
    if (question > this.totalQuestions) {
      this.evaluate();
      return false;
    }

    this.$questionWrap
      .find('.question:nth-of-type(-n+' + (question + 1) + ') img')
      .each(function () {
        $(document).trigger('LazyLoad:reveal', [this]);
      });

    this.$questionWrap
      .removeClass(this.removeQuestionClass)
      .addClass('show-q-' + question);
    this.currentQuestion = question;
    return true;
  };

  this.PersonalityTest.prototype.removeQuestionClass = function (
    index,
    className
  ) {
    return (className.match(/show-q-\d+/g) || []).join(' ');
  };

  /**
   * Select an answer when user clicks the photo.
   * Only two answers can be selected at one time
   */
  this.PersonalityTest.prototype.toggleAnswer = function (e) {
    var $answer = $(e.currentTarget);
    var answerNumber = $answer.index() + 1;
    var $input = $answer.find('input');
    var $question = $answer.closest('.question');
    var questionNumber = $question.index() + 1;

    $question.removeClass('answered');

    // If the input is checked, uncheck it and remove answer
    if ($input.prop('checked')) {
      if (this.answers[questionNumber]) {
        var index = this.answers[questionNumber].indexOf(answerNumber);
        if (index > -1) {
          this.answers[questionNumber].splice(index, 1);
        }
        this.$test.trigger('PersonalityTest:answer:changed');
      }
      $input.prop('checked', false).removeAttr('checked');
      return;
    }

    var selectedAnswers = $answer.siblings().find('input:checked').length;
    if (selectedAnswers >= 2) {
      // Cannot select more than two answers
      return;
    }

    $question.find('.select-answer').slideUp();

    $input.prop('checked', true);
    if (!this.answers[questionNumber]) {
      this.answers[questionNumber] = [];
    }
    this.answers[questionNumber].push(answerNumber);
    this.$test.trigger('PersonalityTest:answer:changed');
  };

  /**
   * Compute the result and evaluate which persona has most points
   * If more personas have the same ammount of points choose one at random
   */
  this.PersonalityTest.prototype.evaluate = function () {
    var personalities = {};
    var mostFrequent;

    for (var question in this.answers) {
      if (
        !this.answers.hasOwnProperty(question) ||
        this.answers[question].length < 1 ||
        !window.ys.ptr.hasOwnProperty(question)
      ) {
        continue;
      }
      for (var i = 0; i < this.answers[question].length; i++) {
        var answer = this.answers[question][i];
        if (!window.ys.ptr[question].hasOwnProperty(answer)) {
          continue;
        }

        for (var j = 0; j < window.ys.ptr[question][answer].length; j++) {
          var personality = window.ys.ptr[question][answer][j];
          if (!mostFrequent) {
            mostFrequent = personality;
          }

          if (!personalities[personality]) {
            personalities[personality] = 1;
          } else {
            ++personalities[personality];
            if (personalities[personality] > personalities[mostFrequent]) {
              mostFrequent = personality;
            }
          }
        }
      }
    }

    if (!mostFrequent) {
      console.log('Could not determine the personality');
    }

    this.showPersona(mostFrequent);
  };

  /**
   * Show the persona result
   */
  this.PersonalityTest.prototype.showPersona = function (name) {
    this.keepOnTop();
    var $persona = $('#' + name);
    if ($persona.length < 1) {
      console.log('The persona was not found!', name);
      return;
    }

    if (typeof dataLayer !== 'undefined') {
      // GTM statistics event
      dataLayer.push({
        event: 'gaEvent',
        eventCategory: 'TDF2017 - Personality test',
        eventAction: 'Result',
        eventLabel: name,
      });
    }

    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    );
    fbq('init', '1411269582230846'); // Insert your pixel ID here.
    fbq('track', 'tdf_test');

    this.$test.addClass('showing-persona');
    this.$test.find('.characters').slideUp();
    this.$questionWrap.slideUp();
    $persona.slideDown();
    $persona.find('img').each(function () {
      $(document).trigger('LazyLoad:reveal', [this]);
    });
  };

  /**
   * Show the persona result
   */
  this.PersonalityTest.prototype.hidePersonas = function () {
    $('.results > div').slideUp();
    this.$test.removeClass('showing-persona');
    this.$test.find('.characters').slideDown();
    this.$questionWrap.slideDown();
  };

  this.PersonalityTest.prototype.reset = function () {
    this.hidePersonas();

    this.$questionWrap
      .find('input')
      .prop('checked', false)
      .removeAttr('checked');
    this.$questionWrap.removeClass(this.removeQuestionClass);

    this.answers = {};
  };

  this.PersonalityTest.prototype.keepOnTop = function () {
    var topPosition = this.$questionWrap.offset().top;
    var topOffset = topPosition - window.scrollY;
    if (topOffset < 0) {
      // need to use object so we can override the value
      var position = {
        top: topPosition,
        left: 0,
      };
      this.$questionWrap.trigger('PersonalityTest:ScrollTo', [position]);
      $('html, body').animate(
        {
          scrollTop: position.top - 20,
        },
        300,
        'swing'
      );
    }
  };

  this.PersonalityTest.prototype.sharePersona = function (e) {
    if (typeof dataLayer !== 'undefined') {
      var persona = $(e.currentTarget).data('persona');
      var site = $(e.currentTarget).data('site');
      // GTM statistics event
      dataLayer.push({
        event: 'gaEvent',
        eventCategory: 'TDF2017 - Personality test',
        eventAction: 'Share',
        eventLabel: site,
      });
      dataLayer.push({
        event: 'gaEvent',
        eventCategory: 'TDF2017 - Personality test',
        eventAction: 'Share - persona',
        eventLabel: persona,
      });
      dataLayer.push({
        event: 'gaEvent',
        eventCategory: 'TDF2017 - Personality test',
        eventAction: 'Shared on ' + site,
        eventLabel: persona,
      });
    }
  };
}).bind(window)(jQuery);
